import { render } from "./ParceiroExport.vue?vue&type=template&id=8209e452"
import script from "./ParceiroExport.vue?vue&type=script&lang=js"
export * from "./ParceiroExport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__